import { BridgePosition, CardPosition, GamePhase, SeatPosition, SharkGameResultsV2 } from '../../app/types';
import { BridgeWarAvatarName } from '../../assets/bridgewars/config';
import { CardUpdateProps } from '../../slices/cardsSlice';
import {
    GameEngine,
    convertIntToBridgePosition,
    intToSuitOrder,
    intToVuln,
    strToCardId,
    swapPlayerIdToBridgePosition,
} from '../game-engine-helper';
import { GameStates, SFSVAR } from '../sfsVar';
import { SFSArray, SFSObject } from 'sfs2x-api';
import { bridgeWarGui, environment } from '../../env';
import {
    bridgeWarLeaderBoard,
    claimButton,
    leaderBoardButton,
    replayButton,
    startPlayButton,
    stopPlayButton,
    undoButton,
} from '../buttonsState';
import { bridgeWarTitleMap, emptyTrick } from '../../app/defaults';
import { clearDomRegistries } from '../../utils/domRegistry';
import { sfsService } from '../sfs-service';

export function MID_NEW_DEAL(cmdObj: SFSObject, sender: GameEngine) {
    MID_CURRENT_DEAL(cmdObj, sender);
    sender.sendRoomCommand(SFSVAR.CMD_TABLE_READY, new SFSObject());
}

export function MID_CURRENT_DEAL(cmdObj: SFSObject, sender: GameEngine) {
    sender.props.table_reset();
    sender.props.table_setTopBridgePosition(BridgePosition.north);
    common(cmdObj, sender);
}

export function MID_NEW_DEAL_SB(cmdObj: SFSObject, sender: GameEngine) {
    MID_CURRENT_DEAL_SB(cmdObj, sender);
    sender.sendRoomCommand(SFSVAR.CMD_TABLE_READY, new SFSObject());
}

export async function MID_CURRENT_DEAL_SB(cmdObj: SFSObject, sender: GameEngine) {
    sender.props.table_reset();
    sender.props.table_setTopBridgePosition(
        swapPlayerIdToBridgePosition(sender.props.app.engineStateInterface.playerID),
    );
    const delay = () => new Promise((resolve) => setTimeout(resolve, 0));
    await delay();
    sender.hideButtons([undoButton, claimButton, startPlayButton, stopPlayButton, replayButton]);
    common(cmdObj, sender);
}

function common(cmdObj: SFSObject, sender: GameEngine) {
   // console.log('MID_CURRENT_DEAL', cmdObj.getDump(true));
    clearDomRegistries();
    sender.props.app_removeModal('awaitApproval');
    sender.props.app_updateEngineInterfaceState({
        currentPlayer: undefined,
    });
    sender.props.table_updateTable({ chat:[] });
    //clear table data.

    sender.props.table_setForceShowAllCards(sender.forceShowAllCards);
    sender.props.table_setIndexButtons(sender.indexButtons);

    const gameState: SFSObject = cmdObj.getSFSObject('tablestate');
    const serverGameState = gameState.getInt('state')
    const showdummy = gameState.containsKey('showdummy') && gameState.getBool('showdummy');
    const showBiddingbox = gameState.containsKey('biddingbox');

    sender.props.table_updateTable({
        vulnerable: intToVuln(gameState.getInt('vuln')),
    });

    if (cmdObj.containsKey('mainmessage')) {
        sender.props.table_setWalkTrough({ content: cmdObj.getUtfString('mainmessage') });
        if (showdummy) {
            sender.props.table_setCardWidthMultiplier(1.35); //Audrey Uses 1.35 multiplier for dummy when walk thru is up
        } else {
            sender.props.table_setCardWidthMultiplier(1.35);  //Audrey Uses 1.35 multiplier for dummy when walk thru is up
        }
    } else {
        sender.props.table_setWalkTrough(undefined);
        if (!showBiddingbox) {
            sender.props.table_setCardWidthMultiplier(1.02);
        } else {
            sender.props.table_setCardWidthMultiplier(1.095);
        }
    }

    //Establish the menu buttons for this screen
    sender.setControlButtons(cmdObj.containsKey('buttons') ? cmdObj.getSFSObject('buttons') : undefined);

    if (gameState.containsKey('tablehtml')) {
        sender.props.table_setBridgeTableHTML(gameState.getUtfString('tablehtml'));
        return;
    }

    sender.props.table_setBridgeTableHTML(undefined);
    sender.props.table_setBridgeTableVisibility(true);

    //reset all cards back to DECK.
    sender.props.cards_reset();

    sender.props.table_setPrimaryLabelToBridgePosition();

    //  sender.props.table_setSuitOrder(intToSuitOrder(gameState.getInt('suitorder')));

    const contract: SFSObject = gameState.getSFSObject('contract'); //declarer
    const declarer: number = contract.getInt('declarer');
    const passed: boolean = contract.getBool('passed');

    const dealer: BridgePosition = convertIntToBridgePosition(gameState.getInt('dealer'));

    sender.props.table_setDealer(dealer);

    if (declarer !== -1 && !passed) {
        //We have contract set declarer
        sender.props.table_setDeclarer(convertIntToBridgePosition(declarer));
    }

    sender.setTableInfo(cmdObj);

    //update hand trays and card holdings
    sender.setHandsFromState(gameState, cmdObj.containsKey('mainmessage'));

    //update auction
    sender.setAuctionFromState(gameState, dealer);

    //update bidding ladder
    sender.setBiddingLadderFromState(gameState);

    sender.setContractFromSFSObject(gameState);

    //Deal with the line of play
    const playArray: SFSArray | undefined = gameState.containsKey('bbplay')
        ? gameState.getSFSArray('bbplay')
        : gameState.containsKey('play')
        ? gameState.getSFSArray('play')
        : undefined;
    if (playArray !== undefined && playArray.size() > 0) {
        setTrickHistory(playArray, sender);
    } else {
        // sender.setCardsToTrickFromHand(gameState);
    }

    sender.props.table_setTrickCounts({
        ns: gameState.getInt('nstr'),
        ew: gameState.getInt('ewtr'),
        goal: gameState.getInt('goal') ?? 0,
    });

    sender.props.table_setShowTrickCounter(gameState.getBool('showtc') ? environment : undefined);

    if (gameState.containsKey('centermessage')) {
        sender.setMessage('center', gameState.getSFSObject('centermessage'));
    }

    if (gameState.containsKey('bleftmessage')) {
        sender.setMessage('left', gameState.getSFSObject('bleftmessage'));
    }

    if (gameState.containsKey('brightmessage')) {
        sender.setMessage('right', gameState.getSFSObject('brightmessage'));
    }

    if (bridgeWarGui) {
        sender.props.table_updateBiddingLadder({ isVisible: false });
        sender.props.table_setComponentContainerPositions({ BiddingKeyboardComponent: 'none' });
        sender.props.table_setComponentContainerPositions({ AuctionBoxComponent: 'none' });
        sender.props.table_setComponentContainerPositions({ TrickCounterComponent: 'none' });
        sender.props.table_setComponentContainerPositions({ SimpleTricksCounterComponent: 'none' });
        sender.props.table_setComponentContainerPositions({ TableSymbolComponent: 'none' });
        Object.values(sender.props.table.seatData).forEach((value) => {
            sender.props.table_setSeatData({
                seatPosition: value?.seatPosition ?? SeatPosition.top,
                isVertical: false,
                cardWidthMultiplier:
                    value?.seatPosition === SeatPosition.top
                        ? 1.9
                        : value?.seatPosition === SeatPosition.left
                        ? 1.3
                        : value?.seatPosition === SeatPosition.right
                        ? 1.3
                        : 1.9,
                dynamicCardColumnsWidth: true,
            });
        });
        if (sfsService.table.containsVariable('meta')) {
            const metaData: SFSObject = sfsService.table.getVariable('meta').value as SFSObject;
            sender.props.table_setSeatData({
                seatPosition: SeatPosition.top,
                bridgeWarAvatar: metaData.getUtfString('nhand') as BridgeWarAvatarName,
                labelPrimary: metaData.getUtfString('nhand'),
            });
            sender.props.table_setSeatData({
                seatPosition: SeatPosition.right,
                bridgeWarAvatar: metaData.getUtfString('ehand') as BridgeWarAvatarName,
                labelPrimary: metaData.getUtfString('ehand'),
            });
            sender.props.table_setSeatData({
                seatPosition: SeatPosition.bottom,
                bridgeWarAvatar: metaData.getUtfString('shand') as BridgeWarAvatarName,
            });
            sender.props.table_setSeatData({
                seatPosition: SeatPosition.left,
                bridgeWarAvatar: metaData.getUtfString('whand') as BridgeWarAvatarName,
                labelPrimary: metaData.getUtfString('whand'),
            });
        }
        const showUndo = playArray !== undefined && playArray.size() >= 2;
        if (showUndo) {
            sender.showButtons([undoButton]);
        }

        return;
    }
    else if (environment === 'shark') {
        let topMultiplier = 1.35;
        let bottomMultiplier = 1.35;
        let leftRightMultiplier = 1.2;
        if (serverGameState >= GameStates.PLAY_SENT_TIME_TO_SCORE) {
            // scoring phase
            topMultiplier = 1.35;
            leftRightMultiplier = 1.2;
        }
        else  if ( serverGameState >= GameStates.AUCTION_CONTRACT_SENT) {
            //in play phase
            topMultiplier = 1.1;
            bottomMultiplier = 1.9;
            //  leftRightMultiplier = 1.3;
        }else if ( serverGameState < GameStates.AUCTION_CONTRACT_SENT ) {
            //bidding phase
            topMultiplier = 1.35;
            leftRightMultiplier = 1.2;
        }

        Object.values(sender.props.table.seatData).forEach((value) => {
            sender.props.table_setSeatData({
                seatPosition: value?.seatPosition ?? SeatPosition.top,
                cardWidthMultiplier:
                    value?.seatPosition === SeatPosition.top
                    ? topMultiplier
                    : value?.seatPosition === SeatPosition.left
                      ? leftRightMultiplier
                      : value?.seatPosition === SeatPosition.right
                        ? leftRightMultiplier
                        : bottomMultiplier,
                dynamicCardColumnsWidth: true,
            });
        });

        sender.showButtonsIfNeeded();
    }

    if (sfsService.table.containsVariable(SFSVAR.SFSGAME_EXTENSION_GAME_RESULTS_V2)) {

        try {
            const resultV = sfsService.table.getVariable(SFSVAR.SFSGAME_EXTENSION_GAME_RESULTS_V2).value as SFSObject;
            if (resultV.containsKey('data')) {
                const json = new TextDecoder('utf-8').decode(resultV.getByteArray('data'));
                const game_results = JSON.parse(json) as SharkGameResultsV2;
                sender.fix_game_results(game_results);
                sender.fix_app_board_data(game_results);
                sender.props.table_setSharkGameResultsV2(game_results);
                sender.showButtons([bridgeWarGui ? bridgeWarLeaderBoard : leaderBoardButton]);
            }
        } catch (e) {
            console.error('could not parse ', e);
        }
    }
}

function setTrickHistory(tricks: SFSArray, sender: GameEngine) {
    const cardUpdates: CardUpdateProps[] = [];
    let winner: BridgePosition | undefined = undefined;
    for (let i = 0; i < tricks.size(); i++) {
        if (i === 0) {
            sender.props.table_addTrick(emptyTrick);
        }
        const card: SFSObject = tricks.getSFSObject(i);
        cardUpdates.push({
            bridgePosition: convertIntToBridgePosition(card.getInt('p')),
            cardPosition: CardPosition.TRICK,
            id: strToCardId(card.getUtfString('c')),
            raised: false,
            highlighted: false,
            visible: true,
        });
        sender.props.table_playCard(strToCardId(card.getUtfString('c')));
        if (card.getBool('w')) {
            winner = convertIntToBridgePosition(card.getInt('p'));
        }
        if (winner !== undefined && i > 0 && (i + 1) % 4 === 0) {
            sender.props.table_claimTrick(winner);
            sender.props.table_addTrick(emptyTrick);
            winner = undefined;
        }
    }
    sender.props.cards_setCards(cardUpdates);
}
